import type { LoadedAuthoredGeneratedSchema } from '@cli-types/core-engine/add-field.js'

export function schemaNameFromLoaded(loaded: LoadedAuthoredGeneratedSchema): string {
  const schemaName = loaded.schema.name
  return typeof schemaName === 'string' && schemaName.trim() ? schemaName : loaded.name
}
